export const isNonProdEnvironment =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_STAGE !== "prod";
